export const PORTFOLIOS_CREATE_ACTIONS = {
  PORTFOLIOS_REQUEST: "PORTFOLIOS_REQUEST",
  PORTFOLIOS_RESPONSE: "PORTFOLIOS_RESPONSE",
  PORTFOLIOS_ERROR: "PORTFOLIOS_ERROR",
};


export const PORTFOLIOS_LIST_ACTIONS = {
  PORTFOLIOS_LIST_REQUEST: "PORTFOLIOS_LIST_REQUEST",
  PORTFOLIOS_LIST_RESPONSE: "PORTFOLIOS_LIST_RESPONSE",
  PORTFOLIOS_LIST_ERROR: "PORTFOLIOS_LIST_ERROR",
};
export const PORTFOLIOS_EXCEL_LIST_ACTIONS = {
  PORTFOLIOS_EXCEL_LIST_REQUEST: "PORTFOLIOS_EXCEL_LIST_REQUEST",
  PORTFOLIOS_EXCEL_LIST_RESPONSE: "PORTFOLIOS_EXCEL_LIST_RESPONSE",
  PORTFOLIOS_EXCEL_LIST_ERROR: "PORTFOLIOS_EXCEL_LIST_ERROR",
};


export const PORTFOLIO_ADD_BYPOSITION = {
  PORTFOLIO_ADD_BYPOSITION_REQUEST: "PORTFOLIO_ADD_BYPOSITION_REQUEST",
  PORTFOLIO_ADD_BYPOSITION_RESPONSE: "PORTFOLIO_ADD_BYPOSITION_RESPONSE",
  PORTFOLIO_ADD_BYPOSITION_ERROR: "PORTFOLIO_ADD_BYPOSITION_ERROR",
};
export const POSITION_UNIT_VALUE = {
  POSITION_UNIT_VALUE: "POSITION_UNIT_VALUE",
};
export const PORTFOLIOS_POSITION_ACTIONS = {
  PORTFOLIOS_POSITION_REQUEST: "PORTFOLIOS_POSITION_REQUEST",
  PORTFOLIOS_POSITION_RESPONSE: "PORTFOLIOS_POSITION_RESPONSE",
  PORTFOLIOS_POSITION_ERROR: "PORTFOLIOS_POSITION_ERROR",
};


export const PORTFOLIOS_EDIT_ACTIONS = {
  PORTFOLIOS_EDIT_REQUEST: "PORTFOLIOS_EDIT_REQUEST",
  PORTFOLIOS_EDIT_RESPONSE: "PORTFOLIOS_EDIT_RESPONSE",
  PORTFOLIOS_EDIT_ERROR: "PORTFOLIOS_EDIT_ERROR",
};


export const PORTFOLIOS_DELETE_ACTIONS = {
  PORTFOLIOS_DELETE_REQUEST: "PORTFOLIOS_DELETE_REQUEST",
  PORTFOLIOS_DELETE_RESPONSE: "PORTFOLIOS_DELETE_RESPONSE",
  PORTFOLIOS_DELETE_ERROR: "PORTFOLIOS_DELETE_ERROR",
};
export const POSITION_DELETE_ACTIONS = {
  POSITION_DELETE_REQUEST: "POSITION_DELETE_REQUEST",
  POSITION_DELETE_RESPONSE: "POSITION_DELETE_RESPONSE",
  POSITION_DELETE_ERROR: "POSITION_DELETE_ERROR",
};


export const POSITION_EDIT_GET_ACTIONS = {
  POSITION_EDIT_GET_REQUEST: "POSITION_EDIT_GET_REQUEST",
  POSITION_EDIT_GET_RESPONSE: "POSITION_EDIT_GET_RESPONSE",
  POSITION_EDIT_GET_ERROR: "POSITION_EDIT_GET_ERROR",
};
export const PORTFOLIOS_POSITION_LIST_ACTIONS = {
  PORTFOLIOS_POSITION_LIST_REQUEST: "PORTFOLIOS_POSITION_LIST_REQUEST",
  PORTFOLIOS_POSITION_LIST_RESPONSE: "PORTFOLIOS_POSITION_LIST_RESPONSE",
  PORTFOLIOS_POSITION_LIST_ERROR: "PORTFOLIOS_POSITION_LIST_ERROR",
};
export const PORTFOLIOS_POSITION_PRICEBYDATE_ACTIONS = {
  PORTFOLIOS_POSITION_PRICEBYDATE_REQUEST: "PORTFOLIOS_POSITION_PRICEBYDATE_REQUEST",
  PORTFOLIOS_POSITION_PRICEBYDATE_RESPONSE: "PORTFOLIOS_POSITION_PRICEBYDATE_RESPONSE",
  PORTFOLIOS_POSITION_PRICEBYDATE_ERROR: "PORTFOLIOS_POSITION_PRICEBYDATE_ERROR",
};
export const PORTFOLIOSLIST_POSITION_ACTIONS = {
  PORTFOLIOSLIST_POSITION_REQUEST: "PORTFOLIOSLIST_POSITION_REQUEST",
  PORTFOLIOSLIST_POSITION_RESPONSE: "PORTFOLIOSLIST_POSITION_RESPONSE",
  PORTFOLIOSLIST_POSITION_ERROR: "PORTFOLIOSLIST_POSITION_ERROR",
};
export const PORTFOLIO_POSITION_UPDATE_ACTIONS = {
  PORTFOLIO_POSITION_UPDATE_RESPONSE: ' PORTFOLIO_POSITION_UPDATE_RESPONSE',
  PORTFOLIO_POSITION_UPDATE_REQUEST: ' PORTFOLIO_POSITION_UPDATE_REQUEST',
  PORTFOLIO_POSITION_UPDATE_ERROR: ' PORTFOLIO_POSITION_UPDATE_ERROR',
};

